import { DateFormField, FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import NationalUniversitySelectField from "../../../../../common/form/fields/NationalUniversitySelectField";
import { useWatch } from "react-hook-form";
import { ARUniEntryRequestRecognizedEduLevel } from "../../../../../../../utils/constants";
import ARUniEntryRequestRecognitionStatusSelectField from "../fields/ARUniEntryRequestRecognitionStatusSelectField";
import ARUniEntryRequestRecognizedEduLevelSelectField from "../fields/ARUniEntryRequestRecognizedEduLevelSelectField";
import ARUniEntryRequestRecognizedSpecialityProfGroupField from "../fields/ARUniEntryRequestRecognizedSpecialityProfGroupField";

const RequestRecognizedSection = () => {
  const recognitionStatusId = useWatch({ name: "recognitionStatus.id" });

  return (
    <FormSection label={"t.arUniEntryRequest.recognized.details"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={12} md={12}>
          <NationalUniversitySelectField
            required={true}
            disabled={true}
            idFieldName={"recognizingUniversity.universityIdentifier"}
            nameFieldName={"recognizingUniversity.universityName"}
            labelCode={"l.arUniEntryRequest.recognizingUniversity"}
          />
        </GridItem>
        <GridItem>
          <ARUniEntryRequestRecognitionStatusSelectField
            required={true}
            labelCode={"l.arUniEntryRequest.recognitionStatus"}
            fieldName={"recognitionStatus.id"}
          />
        </GridItem>
        <GridItem>
          <InputFormField
            required={true}
            labelCode={"l.arUniEntryRequest.protocolNumber"}
            fieldName={"protocolNumber"}
          />
        </GridItem>
        <GridItem>
          <DateFormField required={true} labelCode={"l.arUniEntryRequest.protocolDate"} fieldName={"protocolDate"} />
        </GridItem>

        {recognitionStatusId !== "" && recognitionStatusId !== ARUniEntryRequestRecognizedEduLevel.DENIED && (
          <>
            <GridItem sm={6} md={4}>
              <ARUniEntryRequestRecognizedEduLevelSelectField
                required={true}
                labelCode={"l.arUniEntryRequest.recognizedEducationLevelId"}
                fieldName={"recognizedEducationLevel.id"}
              />
            </GridItem>
            <GridItem sm={6} md={8}>
              <ARUniEntryRequestRecognizedSpecialityProfGroupField />
            </GridItem>
          </>
        )}
      </GridContainer>
    </FormSection>
  );
};
export default RequestRecognizedSection;
